  // env-config.js

  export const EnvType = {
    DEV: "DEV",
    SIT: "SIT",
    UAT: "UAT",
    PROD: "PROD",
  };

  // ✅ Change this to switch environments
  const currentEnv = EnvType.PROD;

  const EnvDetails = {
    currentEnv,

    envs: [EnvType.DEV, EnvType.SIT, EnvType.UAT, EnvType.PROD],

    getServerConfigs() {
      switch (currentEnv) {
        case EnvType.PROD:
          return  "https://api.varanouslabs.com/varanouslabs/";
        case EnvType.UAT:
          return "http://94.136.187.130:8080/varanouslabs/";
        case EnvType.SIT:
          return ""; // Add SIT URL
        case EnvType.DEV:
        default:
          return ""; // Add dev URL
      }
    },
//  return "https://api.varanouslabs.com/varanouslabs/";
  
    getVersionInfo() {
      switch (currentEnv) {
        case EnvType.PROD:
          return "0.0.3";
        case EnvType.UAT:
          return "0.0.5";
        case EnvType.SIT:
          return "3.0.6";
        case EnvType.DEV:
        default:
          return "0.0.1";
      }
    },

    getPushKey() {
      switch (currentEnv) {
        case EnvType.PROD:
          return "BILurGDnbWXGLYF9XxVK_Hm41Yspx72eB3fSXlrhAFoKuIKLnqd0PYm34NZKaH5kBEWp5K5Pib9ub1mRgJheGfs";
        case EnvType.SIT:
          return "BPIg-WqqZGGf5LHws36JjjDke-tvA0Yz_d2NJ2Y0foWJ5b7obJYaitKqbqmes9pFd883pUzXYkAX-Tt4TxFpH9I";
        case EnvType.DEV:
        case EnvType.UAT:
        default:
          return "BPIg-WqqZGGf5LHws36JjjDke-tvA0Yz_d2NJ2Y0foWJ5b7obJYaitKqbqmes9pFd883pUzXYkAX-Tt4TxFpH9I";
      }
    },
  };

export const ServiceURLs = {
  FILE_SERVICE_PATH: "api/files",
};
  export default EnvDetails;
